<template>
  <div v-if="stDataCita" class="px-3">
    <RegistroEnvioLabs400
      v-if="esCoberturaIess"
      :maxEnvios="maxEnvios"
      :saveInState="saveLabs400InState"
      :tokenAtencion="tokenAtencion"
      alertNoRegistros
    />

    <RegistroEnvioLabsAux
      v-if="!esCoberturaIess"
      :saveInState="saveLabsInState"
      :maxEnvios="maxEnvios"
      :tokenAtencion="tokenAtencion"
      alertNoRegistros
    />
  </div>
</template>

<script>

import { mapState } from 'vuex';
import { RegistroEnvioLabs400, RegistroEnvioLabsAux } from '@/views/laboratorio/components';
import { citasService } from '../../services';

export default {

  name: "CrearDerivacionLaboratorio",

  components: {
    RegistroEnvioLabs400,
    RegistroEnvioLabsAux
  },


  created() {
    this.getTokenAtencion();
  },


  data(){

    return {
      tokenAtencion: null
    }
  },


  methods: {


    async getTokenAtencion(){
      this.tokenCita = this.$route.params.token;

      if(!this.tokenCita) return;

      const responseAtencion = await citasService.getAtencion(this.tokenCita);
      if(!responseAtencion || !responseAtencion.length){
        console.error('No se encontraro una atencion');
        return;
      }

      this.tokenAtencion = responseAtencion[0].token;
    },
    
    saveLabsInState(labsList) {
      this.$store.commit("setDataEnvioLaboratorios", labsList);
    },

    saveLabs400InState(labsList) {
      this.$store.commit("setDataEnvioLabs400", labsList);
    }

  },
  
  computed: {
    ...mapState({
      stDataCita     : state => state.citas.ingresoCitas.dataInfoCita,
      stDataCobertura: state => state.citas?.ingresoCitas?.dataInfoCita?.cobertura,
    }),


    esCoberturaIess() {
      return this.stDataCobertura === '1';
    },


    maxEnvios() {
      return this.stDataCobertura === '5' ? null : 1;
    }
  }
}
</script>

